import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

/* Scroll-reveal wrapper — slow, deliberate entrance (opacity + translateY only). */
export const Reveal = ({ children, delay = 0, y = 24, className }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay }}
    >
      {children}
    </motion.div>
  );
};

/* Section eyebrow label with brass tick. */
export const Eyebrow = ({ children, className }) => (
  <div
    className={cn(
      "inline-flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.22em] text-[color:var(--mk-primary-2)]",
      className
    )}
  >
    <span className="h-px w-6 bg-[color:var(--mk-primary)]/70" />
    {children}
  </div>
);

/* Low-opacity geometric souq / arabesque linework overlay for dark hero + login. */
export const SouqMotif = ({ className }) => (
  <div
    aria-hidden
    className={cn("pointer-events-none absolute inset-0 overflow-hidden", className)}
    style={{ mixBlendMode: "soft-light", opacity: 0.06 }}
  >
    <svg width="100%" height="100%" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="souq" width="80" height="92" patternUnits="userSpaceOnUse" patternTransform="scale(1)">
          <g fill="none" stroke="#E7D7BF" strokeWidth="1">
            <path d="M40 0 L80 23 L80 69 L40 92 L0 69 L0 23 Z" />
            <path d="M40 18 L62 31 L62 61 L40 74 L18 61 L18 31 Z" />
            <circle cx="40" cy="46" r="6" />
          </g>
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#souq)" />
    </svg>
  </div>
);
